import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'
import { Section } from '@styles/global.styled'
import MediaHubSearchFrom from '@components/MediaHub/MediaHubSearchForm'
import React from 'react'
import FeaturedArticleHero from '@global/Blocks/FeaturedArticleHero'
import { apiFieldsQuery, defaultImages } from '@lib/variables'
import { getChildPages } from '@lib/api-services/cmsService'
import { NextSeo } from 'next-seo'

const MediaHubLandingPage = ({ latestArticle, pageData }) => {
  const meta = pageData.meta
  const metaTitle = meta.meta_title
  const metaDescription = meta.meta_description
  const ogTitle = meta.og_title || metaTitle
  const ogDescription = meta.og_description || metaDescription
  const ogImage = meta.og_img
    ? [{ url: meta.og_img }]
    : latestArticle.header_image_results?.url
    ? [{ url: latestArticle.header_image_results?.url }]
    : [{ url: defaultImages.mediumNavy }]

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          images: ogImage,
          title: ogTitle,
          description: ogDescription,
        }}
        noindex={true}
        nofollow={true}
      />
      {latestArticle && (
        <Section>
          <FeaturedArticleHero
            heading={latestArticle.title}
            description={latestArticle.meta?.meta_description}
            image={latestArticle.header_image_results?.url}
            link={{ text: 'Read More', url: latestArticle.meta?.path }}
          />
        </Section>
      )}

      <Section>
        <MediaHubSearchFrom
          navigationItems={pageData?.navigation_items}
          hideSearch
        />
      </Section>

      <WagtailBlocksSection blocks={pageData.content_blocks} />
      {
        // instagram feed
        pageData.instagram_feed_code && (
          <div className='block-component'>
            <div className='o-wrapper '>
              <div
                dangerouslySetInnerHTML={{
                  __html: pageData.instagram_feed_code,
                }}
              />
            </div>
          </div>
        )
      }
      {
        // facebook feed
        pageData.facebook_feed_code && (
          <div className='block-component'>
            <div className='o-wrapper '>
              <div
                dangerouslySetInnerHTML={{
                  __html: pageData.facebook_feed_code,
                }}
              />
            </div>
          </div>
        )
      }
    </>
  )
}

MediaHubLandingPage.getInitialProps = async (ctx, pageData) => {
  const queryParams = {
    type: 'blog.BlogPost',
    parentId: null,
    limit: 1,
    page: 1,
    params: {
      order: '-date',
    },
    fields: apiFieldsQuery.BlogPost,
  }

  if (pageData.meta.office_ancestor?.id) {
    queryParams.params.office_id = pageData.meta.office_ancestor.id
  }

  const latestArticle = await getChildPages(
    queryParams.type,
    queryParams.parentId,
    queryParams.limit,
    queryParams.page,
    queryParams.params,
    queryParams.fields
  )

  return {
    latestArticle: latestArticle?.items?.[0],
    pageData,
  }
}

export default MediaHubLandingPage
